/*  */
import { getStyle } from 'lib/DOM';

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
function isFixed(node) {
  while (node && node !== document.body) {
    const position = getStyle(node, 'position');
    if (position === 'fixed') {
      return true;
    }
    node = node.parentNode; // eslint-disable-line no-param-reassign
  }
  return false;
}

export default isFixed;
